// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"c1ca3fc9","370":"f93217dd","524":"64439afa","718":"43b84528","787":"44e9da6d"}[chunkId] + ".chunk.js";
};